import gql from "graphql-tag";

const CREATE_CUSTOMER_SUPPORT = gql`
  mutation contactCustomerSupport($params: ContactCustomerSupportParams!, $subscribeToNewsletter: Boolean!) {
    contactCustomerSupport(params: $params, subscribeToNewsletter: $subscribeToNewsletter)
  }
`;

export default CREATE_CUSTOMER_SUPPORT;
